

import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    data: [],
};


const messagesSlice = createSlice({
    name: 'messages',
    initialState, 
    reducers: {
        setMessages: (state, action) => {
            state.data = action.payload || [];
        },
        addMessage: (state, action) => {
            const msg = action.payload;
            if (!msg) return;
            const exists = state.data.some(m => m.message_id && m.message_id === msg.message_id);
            if (!exists) state.data.unshift(msg);
        },
    },
});



export const { setMessages, addMessage } = messagesSlice.actions;
export default messagesSlice.reducer;